import clusterStore from './clusterstore'
import Request from '../../http/request'
import messenger from '../../messenger/messenger'
import clusterHelper from './clusterhelper'
import {Cluster} from '../../../service/Cluster'
import {DataViz} from '../../../service/DataViz'
import {Layer} from '../../../service/Layer'
import * as R from 'ramda'
import geojsonExtent from '@mapbox/geojson-extent'
import geoViewport from '@mapbox/geo-viewport'
import {EventEmitter} from '../../mixins/eventHandler'
import store from '../../../store'
import MapConstants from '../../common/MapConstants'
import LayerEvents from '../../common/LayerEvents'
import ThemeFactory from '../thematics/modules/ThemeFactory'

const clusterService = Cluster.build({})
const dataVizService = DataViz.build({})
const layerService = Layer.build({})

class ClusterStrategy {
  constructor () {
    this.isActivated = false
    this.resolving = false
    this.clusterOptions = null
    this.map = null
    this._emitter = new EventEmitter()
    this._highLightFillStyle = {
      paint: {
        'fill-color': '#FFFFFF',
        'fill-outline-color': '#000000',
        'fill-opacity': 0.8
      }
    }
    this._threshold = 100000
    this.instance = undefined
    this.request = new Request({tag: 'vectorize'})
    // this.request = new Request({environment: 'local', tag: 'vectorize'})
  }
  static getInstance () {
    if (!this.instance) {
      this.instance = new ClusterStrategy()
    }
    return this.instance
  }
  _prepareClusterStyle (initialColor, finalColor, bins) {
    let circleColor = clusterHelper.getClusterCircleColor(initialColor, finalColor, bins)
    let circleRadius = clusterHelper.getClusterCircleRadius(bins)
    let style = Object.assign(circleColor, circleRadius)
    return style
  }
  _addLineRender (options, style) {
    try {
      const relation = options.pk
      const key = relation.expression
      const layerId = `${options.datavis.native}-${options.layer}`
      const sourceId = `source-${options.datavis.native}-${options.layer}`
      const endPoint = `${this.request.getServiceEndPoint({tagService: 'vectorize'})}/maps/{z}/{x}/{y}/tile.mvt?centroid=false&layer=${options.layer}&columns=${key}`
      const tileUrls = [endPoint]


      if (!options.sourceId ) {}
        this._addSource(sourceId, {
          attribution: '&copy; Cognatis',
          type: 'vector',
          tiles: tileUrls,
          promoteId: `${key}`,
          layer: options.layer,
          layerId: layerId
        })


      this.map.addLayer({
        id: layerId,
        type: 'line',
        maxzoom: style.maxzoom || 24,
        minzoom: style.minzoom || 0,
        source: sourceId,
        'source-layer': options.layer,
        paint: style.paint,
        layout: style.layout
      }, options.beforeId)

      // this._addHighLightRender(options, ['in', relation.expression, ''], this._highLightFillStyle)
      // this._addBorderRender(options, layerId, sourceId)

      // region Mouse events
      /*
      map.on('mousemove', `${layerId}`, function (e) {
        if (e.features.length > 0) {
         console.log(e.features[0])
        }
      })
      */
      /*
      map.on('mousemove', `theme-${options.layer.alias}`, (e) => {
          map.getCanvas().style.cursor = 'pointer';
          const description = `
              <p>Info:  ${d3.format("($.2f")(e.features[0].state[options.themeColumn])}</p>`;
          mapboxUtils.popup
              .setLngLat(e.lngLat)
              .setHTML(description)
              .addTo(map);
      });

      map.on('mouseleave', `theme-${options.layer.alias}`, () => {
          map.getCanvas().style.cursor = '';
          mapboxUtils.popup.remove();
      });
      */
      // endregion
    } catch (e) {
      messenger.error({title: e.message})
    }
  }
  _addBorderRender(options, refLayer, refSource, noBorder = false) {
      const self = this
      const styleType = options.frontier ? 'fb' : 'line';
      const layer = this.map.getLayer(refLayer);
      const stylePromise = options.userDraw
        ? dataVizService.getDefaultStyle('userdrawline')
        : dataVizService.getStyle(options.layer, noBorder ? 'hb' : styleType);

      // debugger;
      stylePromise.then(({ data: lineStyle }) => {
        try {
          // Atualiza o estilo com base nas opções personalizadas
          if (options.datavis.customStyle) {
            const { customStyle } = options.datavis;
            lineStyle.paint['line-color'] = Array.isArray(customStyle.borderColor)
              ? customStyle.borderColor
              : lineStyle.paint['line-color'];
            lineStyle.paint['line-opacity'] = !isNaN(customStyle.borderOpacity)
              ? parseFloat(customStyle.borderOpacity)
              : customStyle.borderOpacity;
            lineStyle.paint['line-width'] = !isNaN(customStyle.borderWidth)
              ? parseFloat(customStyle.borderWidth)
              : customStyle.borderWidth;
          }

          const layerId = `line-${options.layer}`
          const borderWidth = parseFloat(lineStyle.paint['line-width']) || lineStyle.paint['line-width']

          self.map.addLayer({
            id: layerId,
            type: 'line',
            maxzoom: (layer && layer.maxzoom !== undefined) ? layer.maxzoom : 24,
            minzoom: (layer && layer.minzoom !== undefined) ? layer.minzoom : 0,
            source: refSource,
            'source-layer': options.tileSet || options.layer,
            paint: lineStyle.paint,
            layout: lineStyle.layout
          });

          // Define o contorno como transparente se a largura da borda for 0
          if (borderWidth === 0 && layer !== undefined) {
            self.map.setPaintProperty(refLayer, 'fill-outline-color', 'rgba(0,0,0,0)');
          }
        } catch (e) {
          console.error('Erro ao processar o estilo de linha:', e);
        }
      });
  }
  _addCacheRender (options, style) {
    if (!options.hasOwnProperty('tileSet') || options.tileSet.length === 0) {
      throw new Error('Esperada a propriedade tileSet')
    }
    try {
      const relation = options.pk
      const layerId = `${options.datavis.native}-${options.layer}`
      const sourceId = `source-${options.datavis.native}-${options.layer}`
      const tileUrls = [`${this.request.getServiceEndPoint({tag: 'vectorize'})}/maps/${options.tileSet}/{z}/{x}/{y}.vector.pbf`]

      this._addSource(sourceId, {
        attribution: '&copy; Cognatis',
        type: 'vector',
        tiles: tileUrls,
        promoteId: `${relation.expression}`,
        layer: options.layer,
        layerId: layerId,
        isFrontier: options.frontier ? true : false,
        minzoom: 0,
        maxzoom: 14
      })
      // debugger;
      this.map.addLayer({
        id: layerId,
        type: options.datavis.native,
        source: sourceId,
        'source-layer': options.tileSet,
        paint: style.paint,
        layout: style.layout
      }, options.beforeId)

      if (options.datavis.native !== 'line') {
        const highLightStyle = options.datavis.highLightStyle || this._highLightFillStyle
        this._addHighLightRender(options, ['in', relation.expression, ''], highLightStyle)
        this._addBorderRender(options, layerId, sourceId)
      }
      // region Mouse events
      /*
      this.map.on('mousemove', `${layerId}`, function (e) {
        if (e.features.length > 0) {
          console.log(e.features[0])
        }
      })
      */
      // When the mouse moves over the `my-layer` layer,
      // get the feature state for the feature under the mouse
      /*
      this.map.on('mousemove', `${layerId}`, (e) => {
        if (e.features.length > 0) {
          this.map.getFeatureState({
            source: sourceId,
            sourceLayer: options.tileSet,
            id: e.features[0].id
          })
        }
      })
      */
    } catch (e) {
      messenger.error({title: e.message})
    }
  }
  _addCircleRender (options, style) {
    try {
      const relation = options.pk
      let layerId = `${options.datavis.native}-${options.layer}`
      let sourceId = `source-${options.datavis.native}-${options.layer}`
      let endPoint = `${this.request.getServiceEndPoint({tagService: 'vectorize'})}/maps/{z}/{x}/{y}/tile.mvt?centroid=false&layer=${options.layer}`
      let tileUrls = []
      tileUrls.push(endPoint)

      // region Add sources
      this._addSource(sourceId, {
        attribution: '&copy; Cognatis',
        type: 'vector',
        tiles: tileUrls,
        promoteId: `${relation.name}`,
        layer: options.layer,
        layerId: layerId
      })

      // endregion

      /*
      this.map.on('data', (e) => { console.log('A data event occurred.'); console.log(e) })
      this.map.on('dataloading', (e) => { console.log('A dataloading event occurred.'); console.log(e) })
      this.map.on('sourcedata', (e) => { console.log('A sourcedata event occurred.'); console.log(e) })
      this.map.on('styledata', (e) => { console.log('A styledata event occurred.'); console.log(e) })
      this.map.on('styledataloading', (e) => { console.log('A styledataloading event occurred.'); console.log(e) })
      this.map.on('sourcedataloading', (e) => { console.log('A sourcedataloading event occurred.'); console.log(e) })
      */

      // region Add layers
      /* const icon = String.fromCharCode("0xf19c");
      map.addLayer({
        "id": layerId,
        "type": "symbol",
        "source": sourceId,
        "source-layer": options.layer,
        "maxzoom": style.maxzoom,
        "minzoom": style.minzoom,
        layout: {
          'text-line-height': 1, // this is to avoid any padding around the "icon"
          'text-padding': 0,
          'text-anchor': 'center', // center, so when rotating the map, the "icon" stay on the same location
          'text-offset': [0, -0.3], // give it a little offset on y, so when zooming it stay on the right place
          'text-allow-overlap': true,
          'text-ignore-placement': true,
          'text-field': String.fromCharCode("0xF3C5"),
          'icon-optional': true, // since we're not using an icon, only text.
          'text-font': ['Font Awesome 5 Free Solid'],
          'text-size': 35
        },
        paint: {
          'text-translate-anchor': 'viewport', // up to you to change this -- see the docs
          'text-color': '#00FF00' // whatever you want -- can even be data driven using a `{featureProperty}`,
        }
      }); */

      /*
      this.addCustomSymbol().then((img) => {
        map.addImage('airfield_x', img, { sdf: true })
        map.addLayer({
          "id": layerId,
          "type": "symbol",
          "source": sourceId,
          "source-layer": options.layer,
          "maxzoom": style.maxzoom,
          "minzoom": style.minzoom,
          "paint": {
            "icon-color": "#ff0000",
            "icon-halo-color": "#fff",
            "icon-halo-width": 2
          },
          layout: {
            'icon-image': 'airfield_x',
            "visibility": style.layout.visibility
          }
        });
      }, (error) => {
        messenger.error({position: 'top-end', title: error.message})
        console.log(error)
      })
      */

      this.map.addLayer({
        'id': layerId,
        'type': 'circle',
        'source': sourceId,
        'source-layer': options.layer,
        'maxzoom': style.maxzoom,
        'minzoom': style.minzoom,
        paint: style.paint,
        layout: style.layout
      }, options.beforeId)

      /*
      map.addLayer({
        id: `label-vector-${options.layer}`,
        type: "symbol",
        source: sourceId,
        "source-layer": options.layer,
        layout: {
          "text-field": "{cnpj}"
        }
      })
      */

      /*
      this.map.on('mousemove', `${layerId}`, function (e) {
        if (e.features.length > 0) {
          console.log(e.features[0])
        }
      })
      */

      // endregion
    } catch (e) {
      messenger.error({title: e.message})
    }
  }
  _addClusterRender (options, style) {
    const bounds = this.map.getBounds()
    const layerId = `cluster-${options.layer}`
    const sourceId = `source-cluster-${options.layer}`
    /*
    const clusterOptions = {
      'schema': options.schema,
      'table': options.table,
      'where': options.hasOwnProperty('where') ? options.where : null,
      'environment': options.environment,
      'layer': options.layer,
      'minZoom': style.minzoom,
      'maxZoom': style.maxzoom,
      'zoomLevel': Math.round(map.getZoom()),
      'extent': options.extent,
      'radius': style.clusterRadius || 50,
      'rowNumber': options.sampleRate,
      'bbox': [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()]
    }
    */
    const kmeansOptions = {
      'layer': options.layer,
      /* 'threshold': options.maxFeatures, */
      'threshold': this._threshold,
      'rowCount': options.featureCount,
      'clusters': 10,
      'bbox': [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()]
    }
    const self = this
    // clusterService.getData(clusterOptions, {}).then((res) => {
    clusterService.getKMeans(kmeansOptions, {}).then((res) => {
      if (res.status === 404) {
        messenger.info({title: 'Não há dados nesta área'})
        return
      } else if (res.status === 400) {
        const message = res.data.message || res.responseText
        messenger.error({position: 'top-end', title: message})
        return
      }
      /*
      if (res.data.features && res.data.features.length <= 0) {
        messenger.info({title: "Não há dados para o cluster"})
        return;
      }
      */

      const featureCount = res.data.pointCount
      const applyRules = parseFloat(options.maxFeatures) > 0 && parseFloat(options.maxFeatures) < parseFloat(featureCount)
      style.layout.visibility = applyRules ? 'visible' : 'none'
      this._emitter.trigger('clusterSourceChanged', {
        layer: options.layer,
        isSymbol: options.datavis.appendSymbol,
        pointCount: featureCount
      })

      if (res.data.statistics && res.data.statistics.timings) {
        options.datavis.bins = res.data.statistics.bins
        options.datavis.quantiles = res.data.statistics.quantile
        const t = res.data.statistics.timings
        t['features'] = res.data.pointCount
        console.warn(JSON.stringify(t))
      }

      options.redisKey = res.headers['redis-key']
      options.dataSource = `source-cluster-${options.layer}`
      options.datavis.clusterRadius = 50
      // options.enabled = style.layout.visibility === 'visible'
      options.enabled = parseFloat(options.maxFeatures) > 0
      options.pointCount = res.data.pointCount
      options.autoRenew = true
      options.refresh = false
      delete options.datavis.clusterStyle
      delete options.datavis.vectorStyle
      delete options.datavis.labelStyle
      delete options.datavis.symbolStyle
      delete options.map
      options.datavis.style = {'minzoom': 0, 'maxzoom': 24}

      const circleRadius = options.datavis.quantiles.hasOwnProperty('q1')
        ? clusterHelper.getClusterCircleRadius(options.datavis.quantiles)
        : {'circle-radius': 3}
      style.paint['circle-radius'] = circleRadius['circle-radius']

      const bounds = geojsonExtent(res.data.features)
      const canvas = this.map.getCanvas()
      const size = [canvas.width, canvas.height]
      const vp = geoViewport.viewport(bounds, size)

      this.map.flyTo({center: vp.center})

      // region Add sources
      this._addSource(sourceId, {
        'attribution': '&copy; Cognatis',
        type: 'geojson',
        data: res.data.features,
        layer: options.layer,
        layerId: layerId
      })
      // endregion

      const sourceLoadedHandler = function (e) {
        if (e.sourceId !== sourceId || !e.isSourceLoaded) {
          return
        }
        console.log(`Source ${e.sourceId} has totally loaded`)
        const map = e.target
        self._emitter.trigger('mapSourceLoaded', {
          layer: options.layer,
          layerId: layerId,
          sourceId: sourceId,
          pointCount: res.data.pointCount
        })
        map.off('sourcedata', layerId, sourceLoadedHandler)
      }

      this.map.on('sourcedata', layerId, sourceLoadedHandler)

      // region Add layers
      this.map.addLayer({
        id: layerId,
        type: 'circle',
        source: sourceId,
        filter: style.filter,
        paint: style.paint,
        layout: {
          'visibility': style.layout['visibility']
        }
      })

      this.map.addLayer({
        id: `label-${options.layer}`,
        type: 'symbol',
        source: sourceId,
        filter: style.filter,
        paint: {
          'text-color': style.label['text-color'],
          'text-opacity': style.label['text-opacity']
        },
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': style.label['text-size'],
          'visibility': style.layout['visibility']
        }
      })

      /*
      map.addLayer({
        id: "symbol-" + options.layer,
        type: "symbol",
        source: sourceId,
        filter: ["!has", "point_count"],
        layout: {
          "icon-image": "marker-15",
          "text-anchor": "top",
          "text-size": 15,
          "text-offset": [0, 0.6],
          "visibility": style.layout["visibility"]
        }
      });
      */

      // endregion

      clusterStore.save(options)
    }, (error) => {
      if (error.response) {
        if (error.response.status === 400 && error.response.data) {
          if (error.response.data.message === 'column "geom" does not exist') {
            return messenger.info({title: 'Não há geometria nesta camada.'})
          }
          messenger.info({title: error.response.data.message})
        } else if (error.response.status === 404) {
          return messenger.info({title: 'Não há dados nesta área'})
        } else {
          messenger.error({title: error.message})
        }
      } else if (error.status && error.status === 503) {
        messenger.error({title: 'Ops! algo deu errado'})
      } else {
        console.log(error)
      }
    })
  }
  _addHeatmapRender (options, clusterStyle, heatmapStyle) {
    let cluster = clusterStore.getItem(options.layer)
    let layerId = `heatmap-${options.layer}`
    let sourceId = `source-heatmap-${options.layer}`
    if (cluster && cluster.hasOwnProperty('redisKey')) {
      let endPoint = `${this.request.getServiceEndPoint({tagService: 'vectortile'})}/maps/{z}/{x}/{y}/vectorize.mvt?redis=${cluster.redisKey}`
      let tileUrls = []
      tileUrls.push(endPoint)

      // region Add source
      this._addSource(sourceId, {
        'attribution': '&copy; Cognatis',
        type: 'vector',
        tiles: tileUrls,
        layer: options.layer,
        layerId: layerId
      })
      // endregion

      // region Add layer
      this.map.addLayer({
        id: layerId,
        source: sourceId,
        'source-layer': 'locations',
        type: 'heatmap',
        maxzoom: heatmapStyle.maxzoom,
        minzoom: heatmapStyle.minzoom,
        paint: heatmapStyle.paint,
        layout: heatmapStyle.layout
      })
      // endregion

      // regions persistence
      const cs = {
        autoRenew: false,
        datavis: {type: 'heatmap'},
        layer: options.layer,
        redisKey: cluster.redisKey,
        enabled: false
      }
      clusterStore.add(cs)
      // endregion
    } else {
      let bounds = this.map.getBounds()
      let bbox = [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()]
      let clusterOptions = {
        'schema': options.schema,
        'table': options.table,
        'environment': options.environment,
        'layer': options.layer,
        'minZoom': clusterStyle.minzoom,
        'maxZoom': clusterStyle.maxzoom,
        'zoomLevel': Math.round(this.map.getZoom()),
        'extent': options.extent,
        'radius': clusterStyle.clusterRadius || 50,
        'rowNumber': clusterStyle.sampleRate || 100000,
        'bbox': bbox.toString()
      }
      clusterService.getData(clusterOptions, {}).then((res) => {
        if (res.status === 404) {
          messenger.info({title: 'Não há dados nesta área'})
          return
        } else if (res.status === 400) {
          const message = res.data.message || res.responseText
          messenger.error({position: 'top-end', title: message})
          return
        }
        if (res.data.features && res.data.features.length <= 0) {
          messenger.info({title: 'Não há dados para o cluster'})
          return
        }
        if (res.data.statistics && res.data.statistics.timings) {
          console.warn(JSON.stringify(res.data.statistics.timings))
        }

        const redisKey = res.headers['redis-key']
        let endPoint = `${request.getServiceEndPoint({})}/maps/{z}/{x}/{y}/vectorize.mvt?redis=${redisKey}`
        let tileUrls = []
        tileUrls.push(endPoint)

        // region Add source
        this._addSource(sourceId, {
          'attribution': '&copy; Cognatis',
          type: 'vector',
          tiles: tileUrls,
          layer: options.layer,
          layerId: layerId
        })
        // endregion

        // region Add layer
        this.map.addLayer({
          id: layerId,
          source: sourceId,
          'source-layer': 'locations',
          type: 'heatmap',
          maxzoom: heatmapStyle.maxzoom,
          minzoom: heatmapStyle.minzoom,
          paint: heatmapStyle.paint,
          layout: heatmapStyle.layout
        })
        // endregion

        // regions persistence
        const cs = {
          autoRenew: false,
          datavis: {type: 'heatmap'},
          layer: options.layer,
          redisKey: redisKey,
          enabled: false
        }
        clusterStore.add(cs)
        // endregion
      }, (error) => {
        if (error.response) {
          if (error.response.status === 400 && error.response.data) {
            if (error.response.data.message === 'column "geom" does not exist') {
              return messenger.info({title: 'Não há geometria nesta camada.'})
            }
            messenger.info({title: error.response.data.message})
          } else if (error.response.status === 404) {
            return messenger.info({title: 'Não há dados nesta área'})
          } else {
            messenger.error({title: error.message})
          }
        } else if (error.status && error.status === 503) {
          messenger.error({title: 'Ops! algo deu errado'})
        } else {
          console.log(error)
        }
      })
    }
  }
  _addHexagonRender (options, style) {
    try {
      const relation = options.pk
      const self = this
      const layerId = `fill-${options.layer}`
      const sourceId = `source-fill-${options.layer}`
      const endPoint = `${this.request.getServiceEndPoint({tagService: 'cluster'})}/grid/{z}/{x}/{y}/render.pbf?layer=${options.layer}&mode=1`
      const tileUrls = [endPoint]

      this._addSource(sourceId, {
        attribution: '&copy; Cognatis',
        type: 'vector',
        tiles: tileUrls,
        promoteId: `objectid`,
        layer: options.layer,
        layerId: layerId
      })

      const sourceDataHandler = function (e) {
        if (e.sourceId !== sourceId) return false
        if (e.dataType !== 'source') return false
        if (e.type !== 'sourcedata') return false
        const map = e.target
        if (map.getSource(sourceId) && map.isSourceLoaded(sourceId)) {
          self._emitter.trigger('sourceDataChange', {
            map: map,
            layer: options.layer,
            layerId: layerId,
            sourceId: sourceId,
            expression: `${relation.expression}`,
            type: 'hexagon'
          })
          // map.off('sourcedata', layerId, sourceDataHandler)
        }
      }

      // map.on('data', layerId, (e) => eventHandler.DataHandler(options.layer, sourceId, 'Hexagon', e))
      this.map.on('sourcedata', layerId, sourceDataHandler)

      // if (options.beforeId === '') options.beforeId = this._getLabelLayerReference()

      // region Add layers
      this.map.addLayer({
        'id': layerId,
        'type': 'fill',
        'source': sourceId,
        'source-layer': options.layer,
        paint: style.paint,
        layout: style.layout,
        minzoom: style.minzoom,
        maxzoom: style.maxzoom
      }, options.beforeId)

      this._addBorderRender(options, layerId, sourceId, true)

      /*
      const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false
      })
      */

      // this.map.on('mousemove', `${layerId}`, (e) => {
      //   const map = e.target
      //   map.getCanvas().style.cursor = 'pointer'
      //   if (e.features.length === 0) return false
      //   const props = e.features[0].properties
      //   const attrs = Object.keys(props)
      //   let infoBody = ''
      //   for (let i = 0; i < attrs.length; i++) {
      //     infoBody += `<b>${attrs[i]}</b>: ${props[attrs[i]]} <br>`
      //   }
      //   popup.setLngLat(e.lngLat).setHTML(infoBody).addTo(map)
      // })

      /*
      map.on('mouseenter', `${layerId}`, (e) => {
        map.getCanvas().style.cursor = 'pointer'
        if (e.features.length > 0) {
          console.log(e.features[0])
        }
      })
      */
      // Change it back to a pointer when it leaves.
      /*
      this.map.on('mouseleave', `${layerId}`, (e) => {
        const map = e.target
        map.getCanvas().style.cursor = ''
        popup.remove()
      })
      */
      /*
      map.on('mousemove', `${layerId}`, function (e) {
        if (e.features.length > 0) {
          console.log(e.features[0])
        }
      })
      */
      // endregion
      self.activate(options.datavis)
    } catch(e) {
      console.log(e)
      messenger.error({position: 'top-end', title: e.message})
    }
  }
  _addHighLightRender (options = {}, filter = null, style = {}) {
    const layerId = `hl-${options.datavis.native}-${options.layer}`
    const sourceId = `source-${options.datavis.native}-${options.layer}`
    this.map.addLayer(
      {
        'id': layerId,
        'type': options.datavis.native,
        'source': sourceId,
        'source-layer': options.tileSet || options.layer,
        paint: style.paint,
        'filter': filter
      }
    )
  }
  _addFillRender (options, style) {
    try {
      const relation = options.pk
      const key = relation.expression
      const layerId = `${options.datavis.native}-${options.layer}`
      const sourceId = `source-${options.datavis.native}-${options.layer}`
      const endPoint = `${this.request.getServiceEndPoint({tagService: 'vectorize'})}/maps/{z}/{x}/{y}/tile.mvt?centroid=false&layer=${options.layer}&columns=${key}`
      const tileUrls = [endPoint]

      if (!options.sourceId ) {}
        this._addSource(sourceId, {
          attribution: '&copy; Cognatis',
          type: 'vector',
          tiles: tileUrls,
          promoteId: `${key}`,
          layer: options.layer,
          layerId: layerId
        })

      this.map.addLayer({
        id: layerId,
        type: 'fill',
        maxzoom: style.maxzoom || 24,
        minzoom: style.minzoom || 0,
        source: sourceId,
        'source-layer': options.layer,
        paint: style.paint,
        layout: style.layout
      }, options.beforeId)

      this._addHighLightRender(options, ['in', relation.expression, ''], this._highLightFillStyle)
      this._addBorderRender(options, layerId, sourceId)

      // region Mouse events
      /*
      map.on('mousemove', `${layerId}`, function (e) {
        if (e.features.length > 0) {
         console.log(e.features[0])
        }
      })
      */
      /*
      map.on('mousemove', `theme-${options.layer.alias}`, (e) => {
          map.getCanvas().style.cursor = 'pointer';
          const description = `
              <p>Info:  ${d3.format("($.2f")(e.features[0].state[options.themeColumn])}</p>`;
          mapboxUtils.popup
              .setLngLat(e.lngLat)
              .setHTML(description)
              .addTo(map);
      });

      map.on('mouseleave', `theme-${options.layer.alias}`, () => {
          map.getCanvas().style.cursor = '';
          mapboxUtils.popup.remove();
      });
      */
      // endregion
    } catch (e) {
      messenger.error({title: e.message})
    }
  }
  _addLabelRender (options, style) {
    try {
      const relation = options.pk
      const layerId = `label-vector-${options.layer}`
      const sourceId = options.sourceId || `source-label-vector-${options.layer}`
      const endPoint = `${this.request.getServiceEndPoint({tagService: 'vectorize'})}/maps/labels/{z}/{x}/{y}/tile.mvt?centroid=true&layer=${options.layer}&environment=${options.environment}`
      const tileUrls = [endPoint]

      if (!options.sourceId) {
        this._addSource(sourceId, {
          attribution: '&copy; Cognatis',
          type: 'vector',
          tiles: tileUrls,
          promoteId: `${relation.expression}`,
          layer: options.layer,
          layerId: layerId
        })
      }

      this.map.addLayer({
        id: layerId,
        type: 'symbol',
        source: sourceId,
        'source-layer': options.sourceLayer || options.layer,
        minzoom: style.minzoom || 0,
        maxzoom: style.maxzoom || 24,
        layout: style.layout,
        paint: style.paint
      }, options.beforeId)
      /*
      map.on('mousemove', `${layerId}`, function (e) {
        if (e.features.length > 0) {
          console.log(e.features[0])
        }
      })
      */
    } catch(e){
      console.log(e)
      messenger.error({position: 'top-end', title: e.message})
    }
  }
  _addSectorLayerSource (options) {
    try {
      let layerId = 'vector-' + options.layer
      let sourceId = 'source-vector-' + options.layer
      let endPoint = `${this.request.getServiceEndPoint({tagService: 'vectorize'})}/maps/{z}/{x}/{y}/tile.mvt?layer=${options.layer}`
      let tileUrls = []
      tileUrls.push(endPoint)

      this._addSource(sourceId, {
        type: 'vector',
        tiles: tileUrls,
        tileSize: 512,
        minzoom: options.minZoom,
        maxzoom: options.maxZoom,
        layer: options.layer,
        layerId: layerId
      })

      this.map.addLayer({
        id: layerId,
        type: 'fill',
        source: sourceId,
        'source-layer': options.layer,
        paint: {
          'fill-color': 'rgba(0,0,0,0.1)',
          'fill-opacity': 0.8,
          'fill-outline-color': 'rgba(0,0,0,1)'
        },
        layout: {}
      })
    } catch (e) {
      messenger.error({title: e.message})
    }
  }
  _addSource (sourceId, options) {
    if (this.map === null || typeof (this.map) === 'undefined') throw new Error('Mapa não inicializado')
    if (typeof (sourceId) !== 'string') throw new TypeError('sourceId deve ser uma string')
    if (sourceId.length <= 0) throw new Error('sourceId esperado')
    if (Object.keys(options).length === 0) throw new TypeError('options deve ser um objeto válido')
    // TODO Deixamos estes bounds da PJ para testes. Isso precisa ser dinâmico para entrada de LATAM por exemplo - Ferraz
    // if (!Object.hasOwn(options, "bounds")) options.bounds = [-73.99143981933594,-33.750972747802734,-28.84048843383789,5.271790027618408]

    try {
      let source = this.map.getSource(sourceId)
      if (source !== null && source !== undefined) {
        // throw new Error(`Já existe uma source com este id: ${sourceId}`)
      } else {
        this.map.addSource(sourceId, options)

        const self = this
        const sourceLoadedHandler = function (e) {
          if (e.sourceId !== sourceId) return false
          if (!e.target.isSourceLoaded(sourceId)) return false
          if (!self.map.isSourceLoaded(sourceId)) return false
          console.log(`Source ${e.sourceId} has totally loaded`)
          self._emitter.trigger('mapSourceLoaded', {
            layer: options.layer,
            layerId: options.layerId,
            sourceId: sourceId,
            isFrontier: options.isFrontier ? options.isFrontier : options.frontier
          })
          e.target.off('sourcedata', sourceLoadedHandler)
        }

        this.map.on('sourcedata', sourceLoadedHandler)

        return true
      }
    } catch (e) {
      console.log(e)
      return false
    }
  }
  _addSymbolRender (options, style, vector = false) {
    try {
      const relation = options.pk
      let layerId = `symbol-${options.layer}`
      let sourceId = options.sourceId || `source-symbol-${options.layer}`
      let endPoint = `${this.request.getServiceEndPoint({tagService: 'vectorize'})}/maps/{z}/{x}/{y}/tile.mvt?layer=${options.layer}&environment=${options.environment}`
      let tileUrls = [endPoint]

      if (!options.sourceId || vector == true) {
        this._addSource(sourceId, {
          attribution: '&copy; Cognatis',
          type: 'vector',
          tiles: tileUrls,
          promoteId: `${relation.expression}`,
          layer: options.layer,
          layerId: layerId
        })
      }

      if(vector == false){
        this.map.addLayer({
          id: layerId,
          type: 'symbol',
          source: sourceId,
          'source-layer': options.layerId || layerId,
          minzoom: options.minzoom || 0,
          maxzoom: options.maxzoom || 24,
          layout: style.layout,
          paint: style.paint
        }, options.beforeId)
      }
      /*
      map.on('mousemove', `${layerId}`, function (e) {
        if (e.features.length > 0) {
          console.log(e.features[0])
        }
      })
      */
    } catch (erro) {
      console.log(erro)
    }
  }
  _addPointThemeRender (options, style) {
    try {
      let layerId = `${options.resourceType}-${options.layer}`
      let sourceId = `source-${options.resourceType}-${options.layer}`
      let endPoint = `${this.request.getServiceEndPoint({tagService: 'vectorize'})}/maps/{z}/{x}/{y}/tile.mvt?layer=${options.layer}&columns=${options.promoteId}`
      let tileUrls = []
      tileUrls.push(endPoint)

      // region Add sources
      this._addSource(sourceId, {
        attribution: '&copy; Cognatis',
        type: 'vector',
        tiles: tileUrls,
        promoteId: `${options.promoteId}`,
        layer: options.layer,
        layerId: layerId
      })

      // endregion

      // region Add layers
      this.map.addLayer({
        'id': layerId,
        'type': 'circle',
        'source': sourceId,
        'source-layer': options.layer,
        'maxzoom': style.maxzoom,
        'minzoom': style.minzoom,
        'paint': {
          'circle-radius': style.paint['circle-radius'] || 8,
          'circle-color': style.paint['circle-color'],
          'circle-opacity': style.paint['circle-opacity'] || 1,
          'circle-stroke-color': style.paint['circle-stroke-color'] || style.paint['circle-color'],
          'circle-stroke-width': style.paint['circle-stroke-width'] || 0,
          'circle-stroke-opacity': style.paint['circle-stroke-opacity'] || 1
        },
        layout: {
          'visibility': style.layout.visibility
        }
      })
      // endregion
    } catch (e) {
      messenger.error({title: e.message})
    }
  }
  _addPolygonThemeRender (options, style) {
    try {
      let layerId = `${options.resourceType}-${options.layer}`
      let sourceId = `source-${options.resourceType}-${options.layer}`
      let endPoint = `${this.request.getServiceEndPoint({tagService: 'vectorize'})}/maps/{z}/{x}/{y}/tile.mvt?layer=${options.layer}&columns=${options.promoteId}`
      let tileUrls = [endPoint]

      this._addSource(sourceId, {
        attribution: '&copy; Cognatis',
        type: 'vector',
        tiles: tileUrls,
        promoteId: `${options.promoteId}`,
        layer: options.layer,
        layerId: layerId
      })

      this.map.addLayer({
        id: layerId,
        type: 'fill',
        maxzoom: style.maxzoom || 24,
        source: sourceId,
        'source-layer': options.layer,
        paint: style.paint,
        layout: style.layout
      })
    } catch (e) {
      messenger.error({title: e.message})
    }
  }
  _addPointLabelRender(options) {
    const layerId = `label-${options.layer}`
    const sourceId = `source-${options.layer}`
    const basePoint = this.request.getServiceEndPoint({tagService: 'vectorize'})
    const endPoint = `${basePoint}/maps/{z}/{x}/{y}/render.pbf?centroid=true&layer=${options.layer}&table=${options.table}&columns=objectid,requestid,name`;
    const tileUrls = [endPoint];

    this._addSource(sourceId, {
      attribution: '&copy; Cognatis',
      type: 'vector',
      tiles: tileUrls,
      promoteId: 'objectid',
      layer: options.layer,
      layerId: layerId
    });

    this.map.addLayer(
      {
        id: layerId,
        type: 'symbol',
        source: sourceId,
        'source-layer': options.sourceLayer || options.layer,
        layout: {
          'text-field': ['get', 'name'], // Property from your data
          'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
          'text-size': [
            'interpolate', ['linear'], ['zoom'],
            5, 10,   // Small size at low zoom
            12, 12   // Larger size at higher zoom
          ],
          'text-anchor': 'top', // Position relative to point
          'text-offset': [0, 0.6], // Push text above icon
          'text-allow-overlap': false, // Prevents label collisions
          'symbol-placement': 'point'
        },
        paint: {
          'text-color': '#202',
          'text-halo-color': '#fff', // Outline for contrast
          'text-halo-width': 1,
          'text-halo-blur': 0.5
        }
      }
    )

  }
  _addUserDrawLabel(options, style) {
    const layerId = `label-${options.layer}`
    const sourceId = `source-${options.layer}`
    const basePoint = this.request.getServiceEndPoint({tagService: 'vectorize'})
    const endPoint = `${basePoint}/maps/{z}/{x}/{y}/render.pbf?centroid=true&layer=${options.layer}&table=${options.table}&columns=objectid,requestid,name`;
    const tileUrls = [endPoint];

    this._addSource(sourceId, {
      attribution: '&copy; Cognatis',
      type: 'vector',
      tiles: tileUrls,
      promoteId: 'objectid',
      layer: options.layer,
      layerId: layerId
    });

    this.map.addLayer({
       id: layerId,
       type: 'symbol',
       source: sourceId,
       'source-layer': options.sourceLayer || options.layer,
       layout: {
         'text-font': ['DIN Offc Pro Italic', 'Arial Unicode MS Regular'],
         'text-size': 12,
         'text-anchor': 'center',
         'symbol-placement': 'point',
         'text-allow-overlap': false,
         'text-optional': false,
         'text-ignore-placement': false,
         'text-field': ['get', 'name'],
         'symbol-sort-key': ['get', 'objectid'],
         //'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
         'text-radial-offset': 0.5,
         'text-justify': 'auto'
       },
       paint: { 'text-opacity': 1 }
     });
}
  _addUserDrawRender (options, style) {
    try {
      const layerId = `${options.datavis.native}-${options.layer}`
      const sourceId = `source-${options.datavis.native}-${options.layer}`
      const basePoint = this.request.getServiceEndPoint({tagService: 'vectorize'})
      const endPoint = options.userDraw && options.datavis.type !== 'symbol'
        ? `${basePoint}/maps/{z}/{x}/{y}/render.pbf?layer=${options.layer}&table=${options.table}&columns=objectid,requestid,name`
        : `${basePoint}/maps/{z}/{x}/{y}/userdraw.mvt?centroid=false&layer=${options.layer}`
      let tileUrls = [endPoint]

      this._addSource(sourceId, {
        attribution: '&copy; Cognatis',
        type: 'vector',
        tiles: tileUrls,
        promoteId: options.userDraw ? 'objectid' : '',
        layer: options.layer,
        layerId: layerId
      })

      let optionFill = {
        id: layerId,
        type: options.datavis.native,
        maxzoom: style.maxzoom || 24,
        minzoom: style.minzoom || 0,
        source: sourceId,
        'source-layer': options.layer,
        paint: style.paint,
        layout: style.layout
      }
      options.userDraw = true
      this.map.addLayer(optionFill, options.beforeId)
      if (options.datavis.type !== 'symbol')
        this._addBorderRender(options, layerId, sourceId)

      /*
      this.map.on('mousemove', `${layerId}`, function (e) {
        if (e.features.length > 0) {
          console.log(e.features[0])
        }
      })
      */

      /*
      let activeVueInstance = null;
      let activeMenu = null;

      this.map.on("contextmenu", (e) => {
        e.preventDefault(); // Evita o menu padrão do navegador

        if (activeMenu) {
            activeMenu.remove();
            if (activeVueInstance) {
                activeVueInstance.$destroy(); // Destroi a instância Vue ativa
                activeVueInstance = null;
            }
        }

        const features = this.map.queryRenderedFeatures(e.point, { layers: [`${layerId}`] });
        if (features.length > 0) {
            const feature = features[0];

            // Criar um container DOM para o Vue
            const menuContainer = document.createElement("div");
            menuContainer.classList.add("custom-context-menu"); // Adiciona a classe de estilos

            // Criar uma instância do componente Vue dinamicamente
            const PopupComponent = Vue.extend(PopupContent);
            activeVueInstance = new PopupComponent({
                propsData: { feature }
            }).$mount(); // Montar a instância sem anexar a um elemento existente

            menuContainer.appendChild(activeVueInstance.$el); // Adiciona o elemento Vue ao container
            document.body.appendChild(menuContainer); // Adiciona ao body para posicionamento absoluto

            // Posiciona o menu próximo ao cursor
            menuContainer.style.left = `${e.originalEvent.clientX}px`;
            menuContainer.style.top = `${e.originalEvent.clientY}px`;

            activeMenu = menuContainer;

            // Fecha o menu ao clicar fora
            document.addEventListener("click", () => {
                if (activeMenu) {
                    activeMenu.remove();
                    activeVueInstance.$destroy();
                    activeMenu = null;
                    activeVueInstance = null;
                }
            }, { once: true });
        }
    });
    */
    } catch (e) {
      messenger.error({title: e.message})
    }
  }
  _addWmsSource (options) {
    try {
      let wms = options.wms
      let layerId = 'raster-' + options.layer
      let sourceId = 'source-raster-' + options.layer
      let params = Object.keys(wms.options).map(key => key + '=' + wms.options[key]).join('&')
      let tiles = []

      wms.url.forEach(function (url) {
        tiles.push(url + params)
      })

      this._addSource(sourceId, {
        'type': 'raster',
        'tiles': tiles,
        'tileSize': wms.options.width,
        layer: options.layer,
        layerId: layerId
      })

      this.map.addLayer({
        'id': layerId,
        'type': 'raster',
        'source': sourceId,
        'paint': {},
        'layout': {
          visibility: 'none'
        }
      })
    } catch (e) {
      messenger.error({title: e.message})
    } finally {
    }
  }
  _clusterClicked (e) {
    let clusters = clusterStore.items
    if (clusters.length === 0) return
    let map = e.target
    let layers = []
    clusters.forEach(function (cluster) {
      if (cluster.enabled) {
        let layerId = 'cluster-' + cluster.layer
        if (map.getLayer(layerId)) layers.push(layerId)
      }
    })
    if (layers.length === 0) return
    const features = map.queryRenderedFeatures(e.point, {layers: layers})
    if (!features.length) return
    const coordinates = features[0].geometry.coordinates
    const maxZoom = 15

    map.flyTo({
      // These options control the ending camera position: centered at
      // the target, at zoom level 16, and north up.
      center: coordinates,
      zoom: maxZoom,
      bearing: 0,
      speed: 1, // make the flying slow
      curve: 1, // change the speed at which it zooms out
      // This can be any easing function: it takes a number between
      // 0 and 1 and returns another number between 0 and 1.
      easing: function (t) {
        return t
      }
    })
  }
  _clusterInfo (e) {
    let clusters = clusterStore.items
    if (clusters.length === 0) return
    let map = e.target
    // let popup = Vue.prototype.popupInfo
    let layers = []
    clusters.forEach(function (cluster) {
      if (cluster.enabled) {
        let layerId = 'cluster-' + cluster.layer
        if (map.getLayer(layerId)) layers.push(layerId)
      }
    })
    if (layers.length === 0) return
    const features = map.queryRenderedFeatures(e.point, {layers: layers})
    if ((!features.length) || (features[0].properties.point_count == null)) {
      this.map.getCanvas().style.cursor = ''
      // popup.remove()
      return
    }
    // Change the cursor style as a UI indicator.
    this.map.getCanvas().style.cursor = 'pointer'

    // LOOKUP THE HOVERED CLUSTER FEATURES UNDERLYING DATA POINTS
    var clusterId = features[0].properties.cluster_id
    var pointCount = features[0].properties.point_count
    // var all_features = cluster.getLeaves(cluster_id, Math.floor(map.getZoom()), limit = Infinity);

    // DISPLAY THE HOVERED FEATURES IN THE POPUP
    /*
    var features_to_display = []
    all_features.forEach(function(f) {
        features_to_display.push(f.properties["Primary ID"])
    })
    */
    // Populate the popup and set its coordinates
    // based on the feature found.
    popup.setLngLat(features[0].geometry.coordinates)
      .setHTML('Cluster:' + clusterId + '<br/>' + 'Empresas: ' + pointCount)
      .addTo(map)
  }
  _getLabelLayerReference () {
    const layers = this.map.getStyle().layers
    // Find the index of the first symbol layer in the map style.
    let firstSymbolId
    for (const layer of layers) {
      if (layer.type === 'symbol') {
        firstSymbolId = layer.id
        break
      }
    }
    return firstSymbolId
  }
  anyLayerType (map, layerId) {
    let self = this
    let founded = false
    for (let i = 0; i < MapConstants.LayerPrefixes.length; i++) {
      if (self.layerExists(map, `${MapConstants.LayerPrefixes[i]}-${layerId}`)) {
        founded = true
        break
      }
    }
    return founded
  }
  cleanMap (map) {
    let clusters = clusterStore.items
    clusters.forEach(function (cluster) {
      MapConstants.LayerPrefixes.forEach(function (key) {
        let o = map.getLayer(`${key}-${cluster.layer}`)
        let oo = map.getSource(`source-${key}-${cluster.layer}`)
        if (o !== null && o !== undefined) {
          map.removeLayer(`${key}-${cluster.layer}`)
        }
        if (oo !== null && oo !== undefined) {
          map.removeSource(`source-${key}-${cluster.layer}`)
        }
      })
    })
    clusterStore.clear()
  }
  getDefaultClusterStyle (bins) {
    let circleColor = clusterHelper.getClusterCircleColor('#ffffb2', '#fecc5c', bins)
    let circleRadius = clusterHelper.getClusterCircleRadius(bins)
    let props = {
      'circle-blur': 0,
      'circle-opacity': 0.7,
      'circle-stroke-width': 0,
      'circle-stroke-color': '#000000',
      'circle-stroke-opacity': 1
    }
    let style = Object.assign(circleColor, circleRadius)
    let obj = Object.assign(style, props)
    // console.log(JSON.stringify(obj));
    return obj
  }
  getLayerType (map, layerId) {
    let self = this
    let layerType = null
    for (let i = 0; i < MapConstants.LayerPrefixes.length; i++) {
      if (self.layerExists(map, `${MapConstants.LayerPrefixes[i]}-${layerId}`)) {
        layerType = MapConstants.LayerPrefixes[i]
        break
      }
    }
    return layerType
  }
  activate (options) {
    if (this.isActivated) return false
    this.isActivated = true
    this.clusterOptions = options
    this.map.on('zoomstart', (e) => this._startHexBinStrategy(e))
    this.map.on('zoomend', (e) => this._endHexBinStrategy(e))
    // if (options.hasOwnProperty('flyTo') && options.flyTo) { this.map.on('click', this._clusterClicked) }
    // if (options.hasOwnProperty('showInfo') && options.showInfo) { this.map.on('mousemove', this._clusterInfo) }
  }
  append (map, options) {
    if (!R.is(Object, options)) throw new Error('Esperado um Object: options')
    let aggregatorStyle = options.datavis.aggregatorStyle
    let vectorStyle = options.datavis.vectorStyle
    let labelStyle = options.datavis.labelStyle
    let symbolStyle = options.datavis.symbolStyle
    this.map = map

    let baseOptions = {
      'environment': options.environment,
      'pk': options.pk,
      'layer': options.layer,
      'parent': options.parent,
      'table': options.table,
      'sourceId': options.sourceId,
      'layerId': options.layerId,
      'beforeId': options.beforeId,
      'userDraw': options.userDraw,
      'frontier': options.frontier,
      'datavis': options.datavis,
      'tileSet': options.tileSet,
    }
    try {
      // Remove uma eventual instancia
      this.removeLayer(null, this.map, options.layer)
      // Detecta se o beforeId é válido neste momento
      if (options.beforeId && !this.layerExists(this.map, options.beforeId)) {
        baseOptions.beforeId = options.beforeId = null
      }

      if (options.datavis.appendAggregator || options.datavis.mixedMode) {
        // this._addClusterRender(options, aggregatorStyle)
        this._addHexagonRender(options, aggregatorStyle)
      }

      if (options.datavis.appendVector) {
        if (options.userDraw) {
          this._addUserDrawRender(baseOptions, vectorStyle)
          if (options.datavis.type !== 'symbol')
            this._addUserDrawLabel(baseOptions, labelStyle)
          else
            this._addPointLabelRender(baseOptions)
        } else if (options.datavis.mixedMode || options.datavis.native === 'circle') {
          this._addCircleRender(baseOptions, vectorStyle)
        } else if (options.datavis.native === 'symbol' || options.datavis.appendSymbol) {
          this._addSymbolRender(baseOptions, symbolStyle, true)
        } else if (options.datavis.mixedMode || options.datavis.native === 'fill') {
          if (options.tileSet !== null) {
            this._addCacheRender(baseOptions, vectorStyle)
          } else {
            this._addFillRender(baseOptions, vectorStyle)
          }
        } else if (options.datavis.mixedMode || options.datavis.native === 'line') {
          if (options.tileSet !== null) {
            this._addCacheRender(baseOptions, vectorStyle)
          } else {
            baseOptions.frontier = false
            this._addLineRender(baseOptions, vectorStyle)
          }
        } else if (options.datavis.type !== 'cluster' && options.datavis.type !== 'hexagon') {
          throw new Error(`Tipo nativo não tratado: ${options.datavis.native}`)
        }
      }

      if (options.datavis.appendSymbol) {
        this._addSymbolRender(baseOptions, symbolStyle)
      }
      if (options.datavis.appendLabel) {
        this._addLabelRender(baseOptions, labelStyle)
      }
    } catch (e) {
      console.log(e)
      messenger.error({title: e.message})
    }
  }
  deactivate () {
    this.isActivated = false
    this.map.off('moveend', (e) => this.resolve(e))
    if (this.clusterOptions.hasOwnProperty('flyTo') && this.clusterOptions.flyTo) {
      this.map.off('click', this._clusterClicked)
    }
    if (this.clusterOptions.hasOwnProperty('showInfo') && this.clusterOptions.showInfo) {
      this.map.off('mousemove', this._clusterInfo)
    }
  }
  layerExists (map, layerId) {
    try {
      // console.log(map)
      // console.log(layerId)
      if (!map) throw new Error('Esperada a instância de mapa: map')
      if (!layerId) throw new Error('Esperado o identificador do layer: layerId')
      let layer = map.getLayer(layerId)
      return (layer !== null && layer !== undefined)
    } catch (e) {
      console.log(e)
    }
  }
  sourceExists (map, sourceId) {
    try {
      if (!map) throw new Error('Esperada a instância de mapa: map')()
      if (!sourceId) throw new Error('Esperado o identificador da source: sourceId')()
      let source = map.getSource(sourceId)
      return (source !== null && source !== undefined)
    } catch (e) {
      console.log(e)
    }
  }
  _endHexBinStrategy (e) {
    this._recomputeHexBin(e)
    this._afterHexBinRecompute(e)
    this.resolving = !this.resolving

  }
  _startHexBinStrategy (e) {
    if (this.resolving) return false
    this.resolving = !this.resolving
    this._beforeHexBinRecompute(e)
    // this._recomputeHexBin(e)
    // this.resolving = !this.resolving
  }
  _afterHexBinRecompute (e) {
    const map = e.target
    const z = Math.floor(map.getZoom())
    const mapLayers = store.getters['layer/getBaseLayers']
    mapLayers.forEach((layer) => {
      if (!layer.Enabled) return false
      if (!layer.HasHighDensity()) return false
      if (!layer.IsGridType) return false
      if (!layer.IsMixedMode) return false
      if (layer.ShowZoomWarn(z)) {
        map.setLayoutProperty(`fill-${layer.Alias}`, 'visibility', 'visible')
        map.setLayoutProperty(`line-${layer.Alias}`, 'visibility', 'visible')
      }
    })
  }
  _beforeHexBinRecompute (e) {
    const map = e.target
    const z = Math.floor(map.getZoom())
    const mapLayers = store.getters['layer/getBaseLayers']
    mapLayers.forEach((layer) => {
      if (!layer.Enabled) return false
      if (!layer.HasHighDensity()) return false
      if (!layer.IsGridType) return false
      if (!layer.IsMixedMode) return false
      if (layer.ShowZoomWarn(z)) {
        // Desliga o layer para evitar o efeito de colisões (Ferraz)
        // map.setPaintProperty(`fill-${layer.Alias}`, 'fill-color', 'rgba(0,0,0,0)')
        map.setLayoutProperty(`fill-${layer.Alias}`, 'visibility', 'none')
        map.setLayoutProperty(`line-${layer.Alias}`, 'visibility', 'none')
      }
    })
  }
  _recomputeHexBin (e) {
    const map = e.target
    const z = Math.floor(map.getZoom())
    const mapLayers = store.getters['layer/getBaseLayers']
    const self = this

    mapLayers.forEach((layer) => {
      if (!layer.Enabled) return false
      if (!layer.HasHighDensity()) return false
      if (!layer.IsGridType) return false
      if (!layer.IsMixedMode) return false
      if (layer.ShowZoomWarn(z)) {
        const style = layer.Style.GetStyle('hexagon')
        if (!style.hasOwnProperty('custom') || style.custom['color'] === null) {
          style.custom = {
            color: {
              binCount: 9,
              groupName: 'YlOrRd',
              method: {
                value: 3,
                text: 'Quebra Natural (Jenks)'
              }
            }
          }
        }
        const themeOptions = {
          layerId: layer.ObjectId,
          aggregation: 'count',
          colorScheme: style.custom.color.groupName,
          binCount: style.custom.color.binCount,
          method: style.custom.color.method.value,
          zoom: z
        }
        self._emitter.trigger(LayerEvents.ChangeLayerType, {layerId: layer.ObjectId, type: 'hexagon'})
        ThemeFactory.RangedTheme(layer.Alias, 'fill', layer.Table.PrimaryKey, themeOptions)
      } else {
        self._emitter.trigger(LayerEvents.ChangeLayerType, {layerId: layer.ObjectId, type: 'circle'})
      }
    })
    return true
  }
  _resolveHexBin (e) {
    if (this.resolving) return false
    this.resolving = !this.resolving
    this._beforeHexBinRecompute(e)
    // this._recomputeHexBin(e)
    this.resolving = !this.resolving
  }
  remove (mapKey, map, layerId) {
    let clusters = clusterStore.items
    let self = this

    clusters.forEach(function (cluster) {
      if ((cluster.mapKey === mapKey) || (cluster.layer === layerId)) {
        self.removeLayer(mapKey, map, layerId)
      }
    })
    // clusterStore.remove(layerId);
  }
  removeLayer (mapKey, map, layerId) {
    let self = this
    let layerCount = 0
    let sourceCount = 0
    // Remove layer
    for (let i = 0; i < MapConstants.LayerPrefixes.length; i++) {
      const layerId1 = `${MapConstants.LayerPrefixes[i]}-${layerId}`
      if (self.layerExists(map, layerId1)) {
        this.map.removeLayer(layerId1)
        layerCount++
      }
    }
    // Remove source
    for (let j = 0; j < MapConstants.LayerPrefixes.length; j++) {
      const sourceId = `source-${MapConstants.LayerPrefixes[j]}-${layerId}`
      if (self.sourceExists(map, sourceId)) {
        this.map.removeSource(sourceId)
        sourceCount++
      }
    }
    if (layerCount > 0 || sourceCount > 0) {
      console.info(`Removeu: ${layerCount} layers e ${sourceCount} sources`)
    }
  }
  resolve (e) {
    if (clusterStore.items.length <= 0) return
    let clusters = [] // clusterStore.items
    let map = e.target
    let z = Math.round(map.getZoom())
    let bounds = map.getBounds()
    let bbox = [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()]
    const mapLayers = store.getters['layer/getBaseLayers']
    const self = this

    clusters.forEach(function (cluster) {
      // Este bloco serve para controlar o cluster baseado na viewport do mapa (Ferraz)
      /*
      if (map.getLayer(`${cluster.datavis.native}-${cluster.layer}`)) {
        const features = map.queryRenderedFeatures({layers: [`${cluster.datavis.native}-${cluster.layer}`]})
        if (features) {
          if (features.length > 0 && features.length > cluster.maxFeatures) {
            cluster.enabled = true
            clusterStore.save(cluster)
            const emitter = new EventEmitter()
            emitter.trigger('clusterSourceChanged', {
              layer: cluster.layer,
              pointCount: features.length
            })
          } else {
            cluster.enabled = false
          }
        }
      }
      */
      if (cluster.datavis.type === 'cluster' && cluster.enabled) {
        let skipOnce = cluster.hasOwnProperty('refresh')
        if (skipOnce) delete cluster.refresh
        let state = (z >= cluster.datavis.style.maxzoom)
        if (!state && cluster.autoRenew && !skipOnce) {
          const mapLayer = mapLayers.find(x => x.id === cluster.layer)
          const layer = mapLayer.object.layer
          self._emitter.trigger('mapLoading', {status: true})
          layerService.getRowCount(layer, bbox).then((res) => {
            self._emitter.trigger('mapLoaded', {status: false})
            if (res.status === 200) {
              const currentFeatureCount = res.data.count
              const dataVis = layer.jbData.config.datavis
              const maxFeatures = dataVis.hasOwnProperty('maxFeaturesValue') ? dataVis.maxFeaturesValue : dataVis.maxFeatures
              const applyRules = parseFloat(maxFeatures) > 0 && parseFloat(currentFeatureCount) > parseFloat(maxFeatures)
              if (applyRules) {
                /*
                const clusterOptions = {
                  'schema': cluster.schema,
                  'table': cluster.table,
                  'where': cluster.hasOwnProperty('where') ? cluster.where : null,
                  'environment': cluster.environment,
                  'layer': cluster.layer,
                  'minZoom': cluster.clusterOptions.minZoom,
                  'maxZoom': cluster.clusterOptions.maxZoom,
                  'zoomLevel': z,
                  'extent': cluster.extent,
                  'radius': cluster.datavis.clusterRadius,
                  'rowNumber': cluster.sampleRate,
                  'bbox': bbox.toString()
                }
                */
                const kmeansOptions = {
                  'layer': cluster.layer,
                  /* 'threshold': cluster.maxFeatures, */
                  'threshold': self._threshold,
                  'rowCount': currentFeatureCount,
                  'clusters': 10,
                  'bbox': bbox.toString()
                }
                // const requestHeaders = cluster && cluster.redisKey ? {'redis-key': cluster.redisKey} : {}
                // clusterService.getData(clusterOptions, requestHeaders).then((res) => {
                self._emitter.trigger('mapLoading', {status: true})
                clusterService.getKMeans(kmeansOptions, {}).then((res) => {
                  self._emitter.trigger('mapLoaded', {status: false})
                  if (res.status === 200) {
                    if (res.data.statistics && res.data.statistics.timings) {
                      console.warn(JSON.stringify(res.data.statistics.timings))
                    }
                    let source = map.getSource(cluster.dataSource)
                    if (!source) {
                      // eslint-disable-next-line no-useless-escape
                      console.log('Não encontrou source com o id \"' + cluster.dataSource + '\"')
                      clusterStore.remove(cluster.layer)
                    } else {
                      if (res.data.statistics && res.data.statistics.timings) {
                        let logger = {
                          sampleRate: res.data.sampleRate,
                          features: res.data.features.features.length,
                          bins: res.data.statistics.bins,
                          quantiles: res.data.statistics.quantile,
                          timings: res.data.statistics.timings,
                          pointCount: res.data.pointCount
                        }
                        console.warn(JSON.stringify(logger))
                      }
                      cluster.redisKey = res.headers['redis-key']
                      cluster.pointCount = res.data.pointCount
                      cluster.datavis.bins = res.data.statistics.bins
                      cluster.datavis.quantiles = res.data.statistics.quantile
                      source.setData(res.data.features)
                      try {
                        clusterStore.save(cluster)
                        clusterHelper.refreshStyle(map, cluster)
                        self._emitter.trigger('clusterSourceChanged', {
                          layer: cluster.layer,
                          isSymbol: cluster.datavis.appendSymbol,
                          pointCount: res.data.pointCount
                        })
                      } catch (e) {
                        console.log(e)
                      }
                    }
                  } else if (res.status === 404) {
                    messenger.info({title: 'Não há dados nesta área'})
                  } else if (res.status === 400) {
                    messenger.error({position: 'top-end', title: res.data.message || res.responseText})
                  }
                  if (res.data.features && res.data.features.length <= 0) {
                    messenger.info({title: 'Não há dados para o cluster'})
                  }
                }, (error) => {
                  console.log(error)
                  messenger.error({position: 'top-end', title: error.message || 'Erro no cluster'})
                })
              } else {
                self._emitter.trigger('clusterSourceChanged', {
                  layer: cluster.layer,
                  isSymbol: cluster.datavis.appendSymbol,
                  pointCount: currentFeatureCount
                })
              }
            } else {
              messenger.error({position: 'center', title: 'A contagem falhou (BBox)'})
              console.log(res.data)
            }
          }, (error) => {
            messenger.error({position: 'top-end', title: error.message})
            console.log(error)
          })
        }
      }
    })
  }
  toogleDataViz (map, view, layer, skipVector = false) {
    // let cluster = clusterStore.getItem(layer)
    let cl = `cluster-${layer}`
    let ll = `label-${layer}`
    let sl = `symbol-${layer}`
    let hl = `heatmap-${layer}`
    let hl2 = `heatmap-data-${layer}`
    let vl = `circle-${layer}`
    let vl2 = `heatmap-vector-${layer}`
    let fl = `fill-${layer}`

    switch (view.toLowerCase()) {
      case 'cluster':
        if (this.layerExists(map, cl)) map.setLayoutProperty(cl, 'visibility', 'visible')
        if (this.layerExists(map, ll)) map.setLayoutProperty(ll, 'visibility', 'visible')
        if (this.layerExists(map, sl)) map.setLayoutProperty(sl, 'visibility', 'visible')
        if (!skipVector) {
          if (this.layerExists(map, vl)) map.setLayoutProperty(vl, 'visibility', 'visible')
        }
        if (this.layerExists(map, hl)) map.setLayoutProperty(hl, 'visibility', 'none')
        if (this.layerExists(map, hl2)) map.setLayoutProperty(hl2, 'visibility', 'none')
        if (this.layerExists(map, vl2)) map.setLayoutProperty(vl2, 'visibility', 'none')
        if (this.layerExists(map, fl)) map.setLayoutProperty(hl, 'visibility', 'none')
        break

      case 'heatmap':
        if (this.layerExists(map, cl)) map.setLayoutProperty(cl, 'visibility', 'none')
        if (this.layerExists(map, ll)) map.setLayoutProperty(ll, 'visibility', 'none')
        if (this.layerExists(map, sl)) map.setLayoutProperty(sl, 'visibility', 'none')
        if (this.layerExists(map, hl)) map.setLayoutProperty(hl, 'visibility', 'visible')
        if (this.layerExists(map, hl2)) map.setLayoutProperty(hl2, 'visibility', 'visible')
        if (this.layerExists(map, vl)) map.setLayoutProperty(vl, 'visibility', 'visible')
        if (this.layerExists(map, vl2)) map.setLayoutProperty(vl2, 'visibility', 'none')
        break

      case 'fill':
        if (this.layerExists(map, cl)) map.setLayoutProperty(cl, 'visibility', 'none')
        if (this.layerExists(map, ll)) map.setLayoutProperty(ll, 'visibility', 'none')
        if (this.layerExists(map, sl)) map.setLayoutProperty(sl, 'visibility', 'none')
        if (this.layerExists(map, fl)) map.setLayoutProperty(hl, 'visibility', 'visible')
        break

      case 'circle':
        if (this.layerExists(map, cl)) map.setLayoutProperty(cl, 'visibility', 'none')
        if (this.layerExists(map, ll)) map.setLayoutProperty(ll, 'visibility', 'none')
        if (this.layerExists(map, sl)) map.setLayoutProperty(sl, 'visibility', 'none')
        if (this.layerExists(map, hl)) map.setLayoutProperty(hl, 'visibility', 'none')
        if (this.layerExists(map, hl2)) map.setLayoutProperty(hl2, 'visibility', 'none')
        if (this.layerExists(map, vl)) map.setLayoutProperty(vl, 'visibility', 'visible')
        if (this.layerExists(map, vl2)) map.setLayoutProperty(vl2, 'visibility', 'none')
        break

      default:
        console.error(`Tipo não tratado: ${view}`)
    }
  }
  toogleVisibility (map, layerId, state) {
    if (!map) throw new Error('Esperada a instância de mapa: map')
    if (!layerId) throw new Error('Esperado o identificador da layer: layerId')
    if (!this.layerExists(map, layerId)) return false
    map.setLayoutProperty(layerId, 'visibility', state === true ? 'visible' : 'none')
  }
}

const instance = ClusterStrategy.getInstance()
export default instance
